/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const CHIP_COLOR = "#3766E8";

export const TagRoot = styled(Box)(() => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  paddingLeft: 10,
  paddingRight: 10,
  height: 28,
  borderRadius: 999,
  border: "1px solid #CFE0FF",
  backgroundColor: "#F4F8FF",
  color: CHIP_COLOR,
  fontSize: 14,
  fontWeight: 500,
  whiteSpace: "nowrap",
  flexShrink: 0,
}));

export const TagLabel = styled(Typography)(() => ({
  color: CHIP_COLOR,
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1,
}));

export const TagActionsWrapper = styled(Box)(() => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 0,
}));

export const TagIconButton = styled(IconButton)(() => ({
  padding: 2,
  color: CHIP_COLOR,
  "&:hover": {
    backgroundColor: "rgba(55, 102, 232, 0.08)",
  },
}));

export const SubGroupsContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
  width: "100%",
  overflow: "hidden",
}));

export const OverflowBadge = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 30,
  height: 28,
  borderRadius: 999,
  backgroundColor: "lightgray",
  cursor: "pointer",
  fontSize: 14,
  flexShrink: 0,
  color: "gray",
}));

export const EmptyLabel = styled(Typography)(() => ({
  color: "#71717A",
  fontSize: 14,
}));

export const PopoverContent = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  minWidth: 250,
}));
